type LogLevel = "info" | "warn" | "error";

interface LogEntry {
    event: string;
    userId?: string;
    error?: string;
    path?: string;
    status?: number;
    code?: string;
}

function log(level: LogLevel, data: LogEntry) {
    // En producción: omitir "info" — solo warn/error tienen valor en logs del servidor
    if (process.env.NODE_ENV === "production" && level === "info") return;

    const entry = { ...data, ts: new Date().toISOString() };
    const prefix = `[Auth:${data.event}]`;

    if (level === "error") console.error(prefix, entry);
    else if (level === "warn") console.warn(prefix, entry);
    else console.log(prefix, entry);
}

export const authLogger = {
    refreshSuccess: (userId?: string) =>
        log("info", { event: "token_refresh_success", userId }),

    refreshFailed: (error: string, userId?: string) =>
        log("error", { event: "token_refresh_failed", error, userId }),

    sessionExpired: (userId?: string) =>
        log("warn", { event: "session_expired", userId }),

    loginSuccess: (userId: string) =>
        log("info", { event: "login_success", userId }),

    logoutSuccess: (userId?: string) =>
        log("info", { event: "logout_success", userId }),

    unauthorizedAccess: (path: string) =>
        log("warn", { event: "unauthorized_access", path }),

    apiNetworkError: (url: string, code?: string) =>
        log("error", { event: "api_network_error", path: url, code }),

    apiConfigError: (url: string) =>
        log("error", { event: "api_config_error", path: url }),

    apiAuthError: (url: string, status: number) =>
        log("warn", { event: "api_auth_error", path: url, status }),

    apiServerError: (url: string, status: number) =>
        log("error", { event: "api_server_error", path: url, status }),
};
